import {useFirebaseAuth} from '@goschool/react-firebase'
import {useAuthenticationContext} from './AuthenticationContext'
import {useSignInContext} from './SignInContext'
import {useCallback} from 'react'
import {GoogleAuthProvider, signInWithPopup} from 'firebase/auth'
import {IconButton} from '@mui/material'
import GoogleIcon from '@mui/icons-material/Google'

export function GoogleSignInButton() {
  const {auth} = useFirebaseAuth()
  const {enabledMethods} = useAuthenticationContext()
  const {setState, handleError, handleSuccess, resetError} = useSignInContext()

  const signIn = useCallback(
    async () => {
      setState('pending')
      resetError()
      const provider = new GoogleAuthProvider()
      try {
        const credential = await signInWithPopup(auth, provider)
        await handleSuccess(credential)
      } catch (e) {
        handleError(e, 'google')
        setState('failed')
      }
    }, [setState, resetError, auth, handleSuccess, handleError])

  if (!enabledMethods.includes('google')) {
    return null
  }
  return <IconButton onClick={signIn}><GoogleIcon/></IconButton>
}
